import React from "react";
import { LocalLoader } from "../../../loader/localLoader/LocalLoader";

interface TableLoaderProps {
  visibleColumnsLength: number;
}

export const TableLoader = ({ visibleColumnsLength }: TableLoaderProps) => {
  return (
    <tr className="no-data-row">
      <td colSpan={visibleColumnsLength} className={"table-loader"}>
        <LocalLoader />
      </td>
    </tr>
  );
};
